<template>
  <flow-step-empty-base
    :name="flowStepTitle"
    :imgPath="img"
    :description="flowStepLabel"
    @cta-click="handleCTA"
    :locked="$store.getters.isLiteSubscriber"
    :ctaLoading="reloadingCoupons"
    :ctaText="ctaText"
  >
    <div v-if="missingPauseCoupon && stepOfferType === OFFER_TYPE.PAUSE">
      <p class="text-brand-black font-semibold text-sm">
        Before you can enable customers to pause their accounts during your cancellation flow, you will need to create a discount in your Braintree
        dashboard with the id
        <span class="text-green-700 font-bold"> {{ BRAINTREE_PAUSE_DISCOUNT_ID }}</span>
      </p>
      <p class="font-bold text-brand-black mt-4">Why?</p>
      <p class="text-sm">
        Braintree does not have a "pause" feature. Churnkey can emulate it for you with the CHURNKEY_PAUSE discount. You can make the discount for any
        amount.
      </p>
    </div>
    <div v-else>
      {{ flowStepExplanation }}
    </div>
  </flow-step-empty-base>
</template>

<script>
import FlowStepEmptyBase from '@/components/FlowSteps/FlowStepEmptyBase.vue';
import { FETCH_ORG_COUPONS } from '@/store/action-types';
import { OFFER_TYPE, BRAINTREE_PAUSE_DISCOUNT_ID } from '@/store/shared';
import { mapGetters } from 'vuex';
import img from '@/assets/img/icon-initialoffer.svg';

export default {
  name: 'FlowStepOfferEmpty',
  components: {
    FlowStepEmptyBase,
  },
  props: {
    step: {
      type: Object,
      required: false,
    },
    isFinalOffer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      OFFER_TYPE,
      BRAINTREE_PAUSE_DISCOUNT_ID,
      reloadingCoupons: false,
      img,
    };
  },
  methods: {
    handleCTA() {
      if (this.missingPauseCoupon) {
        this.reloadCoupons();
      } else {
        this.$emit('cta-click');
      }
    },
    async reloadCoupons() {
      this.reloadingCoupons = true;
      await this.$store.dispatch(FETCH_ORG_COUPONS, true);
      if (!this.hasPauseCoupon) {
        this.$message({
          type: 'warning',
          message: 'Could not find the CHURNKEY_PAUSE discount. Please create it in your Braintree dashboard.',
          duration: 5000,
        });
      }
      this.reloadingCoupons = false;
    },
  },
  computed: {
    ...mapGetters(['provider', 'missingPauseCoupon', 'hasPauseCoupon']),
    ctaText() {
      return this.missingPauseCoupon ? 'I have created a CHURNKEY_PAUSE discount →' : 'Enable This Step →';
    },
    stepOfferType() {
      return this.step?.offer?.offerType;
    },
    flowStepTitle() {
      return this.isFinalOffer ? 'Final Offer' : 'Initial Offer';
    },
    flowStepLabel() {
      return this.isFinalOffer ? 'Present customers with a final offer.' : 'Present customers with an initial offer.';
    },
    flowStepExplanation() {
      if (this.isFinalOffer) {
        return 'This is the last offer you will present to customers before they cancel. You can offer them a discount, a pause, or anything else.';
      }
      return "Present customers with an initial offer. Even if a customer does not accept this offer, it gets them to actively thinking about your product's value to them.";
    },
  },
};
</script>
